import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./layout/Layout";
import GenericScreen from "./screens/GenericScreen";
import { HeaderNavProvider } from "./context/HeaderNavContext";
import { getCurrentUserRole, getDefaultRouteForRole } from "./core/auth";

function HomeRedirect() {
  const target = getDefaultRouteForRole(getCurrentUserRole());
  return <Navigate to={target} replace />;
}

export default function App() {
  return (
    <HeaderNavProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<GenericScreen />} />
        <Route
          path="*"
          element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomeRedirect />} />
                <Route path="/:module/:id" element={<GenericScreen />} />
                <Route path="/:module" element={<GenericScreen />} />
              </Routes>
            </Layout>
          }
        />
      </Routes>
    </BrowserRouter>
    </HeaderNavProvider>
  );
}